<template>
    <div class="mr-2 md:mr-0 flex items-center relative" >
        <client-only>
            <div @click="toggleUserDropdown" ref="userNavIcon" class="cursor-pointer">
                <FontAwesomeIcon icon="user" :class="userIconClass"/>
            </div>
        </client-only>
        <div v-if="showUserDropdown" @click="destroyCart" class="p-2 absolute top-10 right-0 shadow text-grey-dark bg-white cursor-pointer z-50">
            <span>Uitloggen</span>
        </div>
    </div>
</template>

<script setup>

    const cartStore = useCartStore();
    const snackbar = useSnackbar();
    const { authSource } = storeToRefs(cartStore);
    const showUserDropdown = ref(false);
    const userNavIcon = ref(null);

    const loggedIn = computed(() => authSource.value == 'acm' || authSource.value == 'azure');
    const userIconClass = computed(() => loggedIn.value === true ? 'text-green-600' : '');

    onMounted(() => {
        document.addEventListener("click", (e) => {
            if (e.target != userNavIcon.value && e.target != userNavIcon.value?.firstChild && e.target != userNavIcon.value?.firstChild?.firstChild) {
                closeUserDropdown();                       
            }
        })
    })

    const toggleUserDropdown = () => {
        if (loggedIn.value !== true) {
            navigateTo('/inloggen');
            return;
        }

        showUserDropdown.value = !showUserDropdown.value;
    }

    const closeUserDropdown = () => {
        showUserDropdown.value = false;
    }

    const destroyCart = () => {
        cartStore.destroyCart();
        snackbar.top = true;
        snackbar.add({
            type: 'success',
            text: 'U bent succesvol uitgelogd',
        });
    }

</script>
